import { BadgeStyled } from '@procurify/ui'
import styled from 'styled-components'

import { TabStyled } from './TabStyled'
import { type ITabsProps } from '../Tabs'

export const TabsStyled = styled.div<ITabsProps>`
  display: flex;
  gap: ${(props) => props.theme.space.medium};
  padding-left: ${(props) => props.theme.space.medium};

  ${(props) =>
    props.isFiltered &&
    `
    ${TabStyled} {
      ${BadgeStyled}  {
        background-color: ${props.theme.colors.badge.inactive.background};
        color: ${props.theme.colors.badge.inactive.content};
      }
      
      &.active ${BadgeStyled}  {
        background-color: ${props.theme.colors.badge.incomplete.background};
        color: ${props.theme.colors.badge.incomplete.content};
      }
    }
    `}
`
